import { Stack } from "@mui/material";
import { CheckList } from "../CheckList";
import { DatasetNameBlock } from "../DatasetNameBlock";

export const PreviewBlock = ({
  checkState,
  setShowDetails,
  showDatasetInfo,
  setShowDatasetInfo,
  datasetName,
  //onContinueClick,
  isPopup = false,
}) => {
  return (
    <Stack
      height="100%"
      minHeight="fit-content"
      backgroundColor="#F9FAFB"
      alignItems="center"
      justifyContent="center"
      boxSizing="border-box"
      gap="40px"
      p="40px"
      sx={{ borderRadius: isPopup ? "12px" : "0px" }}
    >
      {showDatasetInfo && <DatasetNameBlock {...{ setShowDatasetInfo, datasetName }} />}

      <CheckList {...{ checkState, setShowDetails }} />

      {/*{!isPopup && (
        <Button
          sx={{
            mt: "40px",
            fontSize: "18px",
            width: "260px",
            height: "54px",
            ml: "auto",
          }}
          variant="contained"
          onClick={onContinueClick}
        >
          Continue
        </Button>
      )}*/}
    </Stack>
  );
};
